import { render, staticRenderFns } from "./PartnerLogos2.vue?vue&type=template&id=50ee478b&scoped=true"
import script from "./PartnerLogos2.vue?vue&type=script&lang=js"
export * from "./PartnerLogos2.vue?vue&type=script&lang=js"
import style0 from "./PartnerLogos2.vue?vue&type=style&index=0&id=50ee478b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ee478b",
  null
  
)

export default component.exports